import module from 'finanzas/module.js'
import * as moment from 'moment'

const schema = {
  Fecha_Movimiento: 'date',
  Importe: 'number',
  Interes: 'number',
  Status: 'boolean',
  Captura_Fecha: 'timestamp',
}

export class FinanzasServiciosAgregadosService {
  constructor ($http) {
    this.$http = $http
  }

  get (empresas, fechaInicial, fechaFinal) {
    return this.$http.get('/kendu/finanzas/serviciosAgregados/seleccionar', {
      params: {
        empresas: empresas.join(','),
        fecha_inicial: moment(fechaInicial).format('YYYY-MM-DD'),
        fecha_final: moment(fechaFinal).format('YYYY-MM-DD'),
      },
      schema,
    })
  }
}

module.service('FinanzasServiciosAgregados', FinanzasServiciosAgregadosService)



// WEBPACK FOOTER //
// ./src/finanzas/services/FinanzasServiciosAgregados.js